import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationBinSchema } from "./consolidation-bin-fields";

export const listConsolidationBins = {
  name: "listConsolidationBins" as const,
  input: z.object({ returnsCenterId: returnsCenterIdFormat.schema }),
  output: z.object({ bins: z.array(ConsolidationBinSchema) }),
};
